import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/69f5372d63911b0014149774/infokelulusan/src/app/student-login-screen/components/StudentLoginClient.tsx");
